module.exports = __webpack_public_path__ + "img/lang-en.cc2de559.png";